module.exports = __webpack_public_path__ + "static/img/winter.b5efc2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/d_tree1_young/winter.png
// module id = 1NMW
// module chunks = 1